import React, { useEffect, useState, useReducer } from "react";
import { Row, Col, Form, Modal } from "react-bootstrap";
import { FaExchangeAlt, FaLock } from "react-icons/fa";
import { BiSortAlt2 } from "react-icons/bi";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { useMiddletier } from "../../../../common/middletier";
import Loading from '../../../../components/Loading';
// import { useForm } from "react-hook-form";
import { useLocation } from 'react-router-dom';
// import { FaInfoCircle } from "react-icons/fa";
// import { GLOBAL_BUCKET, GAME_MENU_DATA, GAME_WALLET_CATEGORY } from '../../../../common/constants';
import { useStoreState, useStoreDispatch, APP_STORE_ACTION } from '../../../../common/storeContext'
import { useNavigate } from "react-router-dom"

const TRANSFER_ACTION = {
    SET_TRANSFER_TARGET: 'SET_TRANSFER_TARGET',
    SET_SELECTED_TRANSFER_TARGET: 'SET_SELECTED_TRANSFER_TARGET',
    SET_TRANSFER_USERNAME: 'SET_TRANSFER_USERNAME',
    SET_TRANSFER_AMOUNT: 'SET_TRANSFER_AMOUNT',

}

const initialTransferData = {
    transferTarget: [ { id: 'MEMBER', name: 'member' }],
    selectedtTransferTarget: { id: 'MEMBER', name: 'member' },
    transferUsername: '',
    transferAmount: 0,
}

const transferReducer = (state, action) => {
    switch (action.type) {

        case TRANSFER_ACTION.SET_TRANSFER_TARGET: {
            const transferTarget = [...action.payload]
            return { ...state, transferTarget };
        }

        case TRANSFER_ACTION.SET_SELECTED_TRANSFER_TARGET: {
            const selectedtTransferTarget = state.transferTarget.find((transferTarget) => transferTarget.id === action.payload)
            return { ...state, selectedtTransferTarget };
        }

        case TRANSFER_ACTION.SET_TRANSFER_USERNAME: {
            const transferUsername = action.payload
            return { ...state, transferUsername };
        }

        case TRANSFER_ACTION.SET_TRANSFER_AMOUNT: {
            return { ...state, transferAmount: action.payload };
        }

        default: {
            throw new Error(`Unhandled action type: ${action.type}`)
        }
    }
}


const Transfer = () => {
    const location = useLocation()
    const appDispatch = useStoreDispatch()
    const appState = useStoreState()
    const { t, i18n } = useTranslation();
    const { queries, mutation, query } = useMiddletier()
    const [transferState, transferDispatch] = useReducer(transferReducer, initialTransferData)
    const [usernameExist, setUsernameExist] = useState(false);
    const [disabledSubmit, setDisabledSubmit] = useState(true);
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 992px)'
    })



    const onChangeTransferTarget = (newValue) => {
        transferDispatch({ type: TRANSFER_ACTION.SET_SELECTED_TRANSFER_TARGET, payload: newValue })
    }

    const onChangeTransferUsername = (newValue) => {
        transferDispatch({ type: TRANSFER_ACTION.SET_TRANSFER_USERNAME, payload: newValue })
    }


    const onChangeTansferAmount = (newValue) => {
        transferDispatch({ type: TRANSFER_ACTION.SET_TRANSFER_AMOUNT, payload: newValue })
    }



    const clearInput = () => {
        transferDispatch({ type: TRANSFER_ACTION.SET_SELECTED_TRANSFER_TARGET, payload: 'MEMBER' })
        transferDispatch({ type: TRANSFER_ACTION.SET_TRANSFER_USERNAME, payload: '' })
        transferDispatch({ type: TRANSFER_ACTION.SET_TRANSFER_AMOUNT, payload: 0 })
        setUsernameExist(false)
    }



    // CHECK IF USERNAME EXIST
    const checkUsername = () => {

        if (transferState.transferUsername?.length > 0) {
            const method = 'checkAffiliateTransferTarget'

            query({
                method,
                params: [
                    { code: 'username', graphqlType: 'String', required: true, value: transferState.transferUsername },
                    { code: 'type', graphqlType: 'String', required: true, value: transferState.selectedtTransferTarget?.id },
                ],
                attributes: []

            }).then(({ data }) => {
                setUsernameExist(true)


            }).catch((error) => {
                console.log('error: ', error)
                setUsernameExist(false)
                appDispatch({
                    type: APP_STORE_ACTION.SHOW_ALERT,
                    payload: { description: error.message.toString(), typeAlert: 'error' }
                });
            })
        }

    }


    // TRANSFER SUBMIT
    const handleSubmit = () => {

        setLoading(true)
        const method = 'transferByAffiliate'

        let params = [
            { code: 'transferTarget', graphqlType: 'String', required: true, value: transferState.selectedtTransferTarget?.id },
            { code: 'username', graphqlType: 'String', required: true, value: transferState.transferUsername },
            { code: 'amount', graphqlType: 'Float', required: true, value: parseFloat(transferState.transferAmount) },
        ]

        mutation([{
            method,
            params,
            attributes: []

        }])
            .then(({ data }) => {
            
                appDispatch({
                    type: APP_STORE_ACTION.REFRESH_DEPOSIT_WALLET_AMOUNT,
                    payload: data[method]?.after_balance
                })
                clearInput()
                setLoading(false)
                appDispatch({
                    type: APP_STORE_ACTION.SHOW_ALERT,
                    payload: { description: 'Transfer Successful', typeAlert: 'success' }
                });
            })
            .catch((error) => {
                setLoading(false)
                console.log('error: ', error)
                if (error?.networkError?.statusCode === 401) {
                    appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
                } else {
                    appDispatch({
                        type: APP_STORE_ACTION.SHOW_ALERT,
                        payload: { description: error.message.toString(), typeAlert: 'error' }
                    });
                }
            })
    };










    // CHECK FORM SUBMIT
    useEffect(() => {
        if (transferState.selectedtTransferTarget?.id !== '' && (transferState.transferAmount > 0 || ((transferState.transferAmount > 0 || transferState.transferAmount === '') && (transferState.selectedPromotion?.id !== '' || transferState.promotionCode !== '')))) {
            setDisabledSubmit(false)
        }
        else {
            setDisabledSubmit(true)
        }

    }, [transferState.selectedtTransferTarget?.id, transferState.transferAmount, transferState.selectedPromotion?.id, transferState.promotionCode])





    return (
        <>
            <div className="transfer_body">
                <div className="wallet_container_wrap">
                    <Row>
                        <Col lg={12}>
                            <Form className="transfer_form">
                                <Form.Group className="form_input_wrap" >
                                    <div className="input_wrap_row ">
                                        <div className="transferFrom_col">
                                            <Form.Label>{t('transfer_target')}
                                                <span className="form_required_input">*</span>
                                            </Form.Label>
                                            <Form.Select aria-label="transfer_target" className="input_transferTarget" value={transferState.selectedtTransferTarget?.id} onChange={(evt) => { onChangeTransferTarget(evt.target.value) }}>
                                                <option hidden></option>
                                                {transferState?.transferTarget?.map(function (item) {
                                                    return (

                                                        <option value={item.id} key={item.id} >{t(item.name)}</option>
                                                    )
                                                })}
                                            </Form.Select>
                                        </div>
                                        <div className="font_h2 transferIcon_col">
                                            <div className="d-flex">
                                            </div>
                                        </div>
                                        <div className="transferTo_col">
                                            <Form.Label>{t('username')}
                                                <span className="form_required_input">* </span>
                                            </Form.Label>
                                            <div className="w-100 position-relative d-flex align-items-center">
                                                <Form.Control
                                                    type="text"
                                                    name="transferUsername"
                                                    value={transferState?.transferUsername}
                                                    className="input_transferUsername"
                                                    aria-label="transferUsername"
                                                    onChange={(evt) => { onChangeTransferUsername(evt.target.value) }}
                                                    autoComplete="off"
                                                    onKeyDown={(event) => {
                                                        if (event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    onInput={(event) => {
                                                        if (event.target.value.includes(' ')) {
                                                            event.target.value = event.target.value.replace(/ /g, '');
                                                        }
                                                        event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
                                                    }}
                                                />

                                                <input type={'button'} value={t('search')} className={`color_button btnSearch`} onClick={() => checkUsername()} />
                                            </div>
                                        </div>
                                    </div>
                                </Form.Group>
                                <hr className="mt-4" />

                                <Form.Group className="form_input_wrap" >
                                    <div className="input_wrap">
                                        <Form.Label>{t('transfer_amount')}
                                            <span className="form_required_input">* {t('required_fill_in')}</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            // step={1}
                                            // placeholder={t('transfer_amount_placeholder')}
                                            className="input_transferAmount"
                                            min={0}
                                            value={transferState.transferAmount === 0 ? '' : transferState.transferAmount}
                                            onChange={(evt) => { onChangeTansferAmount(evt.target.value) }}
                                            onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                            aria-label="transferAmount"
                                            disabled={!usernameExist}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                            }}
                                        />

                                    </div>

                                </Form.Group>

                                <input className="font_button color_button wallet_btnCancel" type='button' onClick={() => clearInput()} value={t('cancel')} />
                                <input className="font_button color_button wallet_btnSubmit" type='button' onClick={() => handleSubmit()} value={t('transfer')} disabled={disabledSubmit} />
                            </Form>
                        </Col>
                    </Row>

                </div>
            </div>
            {isLoading && (<Loading />)}
        </>

    );
};




export default Transfer;
